import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Chip, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { GET_ROUTE_CUSTOMER } from '../../../core/constants';
import { getCustomersState } from '../../../features/customer/get_customers';
import { getCustomerStatus, getCustomerStatusColor } from '../../common/utils/customer_utils';

const CustomersList = ({ queryParams }) => {
    const navigate = useNavigate();
    const getCustomers = useSelector(getCustomersState);

    return (
        <TableContainer component={ Paper } variant="outlined">
            <Table stickyHeader>
                <TableHead>
                    <TableRow sx={ { '& th': { backgroundColor: 'slate.50', fontWeight: 600 } } }>
                        <TableCell>ID</TableCell>
                        <TableCell>Imię</TableCell>
                        <TableCell>Nazwisko</TableCell>
                        <TableCell align="center">Nr telefonu</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell align="center">Status</TableCell>
                        <TableCell align="right" sx={ { minWidth: 100 } }></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { getCustomers?.data?.content?.map(customer => (
                        <TableRow key={ customer?.id } hover>
                            <TableCell sx={ { fontWeight: 600 } }>
                                { customer?.id }
                            </TableCell>
                            <TableCell>
                                { customer?.name }
                            </TableCell>
                            <TableCell>
                                { customer?.surname }
                            </TableCell>
                            <TableCell align="center">
                                <Typography variant="body2">
                                    +{ customer?.phonePrefix?.prefix } { customer?.phoneNumber }
                                </Typography>
                            </TableCell>
                            <TableCell>
                                { customer?.email }
                            </TableCell>
                            <TableCell align="center">
                                <Chip
                                    label={ getCustomerStatus(customer?.status) }
                                    color={ getCustomerStatusColor(customer?.status) }
                                    size="small"
                                />
                            </TableCell>
                            <TableCell align="right">
                                <Stack direction="row" justifyContent="flex-end" spacing={ 1 }>
                                    <Tooltip title="Podgląd">
                                        <IconButton
                                            size="small"
                                            onClick={ () => navigate(GET_ROUTE_CUSTOMER(customer?.id), { state: { queryParams } }) }
                                        >
                                            <SearchIcon fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )) }
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default CustomersList;